define('Adobe/dataLayer',["util"], function (util) {
    return {
        pageDataBlacklist: ["/search", "/purchase/checkout", "/purchase/reviewandpay", "/purchase/passengerdetails"],

        bookingEngineLocalStorageItems: [
            "assistanceRequired",
            "boardBasis",
            "bookingReference",
            "cabinGrade",
            "cabinGuaranteeType",
            "cabinSubgrade",
            "carrierPreference",
            "contactPreference",
            "departureDate",
            "departurePoint",
            "medicalCondition",
            "numberOfNights",
            "occupancy",
            "pandiState",
            "passengerNumber",
            "paymentOption",
            "paymentReturn",
            "quoteReference",
            "totalPrice",
            "TransactionNumber",
            "transportType",
            "travelInsurance",
            "metaTravelStartDate",
            "metaTravelEndDate"
        ],

        clearCheckoutAndBookingEngineItemsFromLocalStorage: function (transactionNumber) {
           this.bookingEngineLocalStorageItems.forEach(function(item) { localStorage.removeItem(item); });
           localStorage.setItem("TransactionNumber", transactionNumber);
        },

        run: function () {
            var dataLayerModule = this,
                nullPageName = (window.location.pathname == "/"),
                pageName = "";

            // if not nullPageName then work out what it should be and assign to the variable
            if (!nullPageName) {
                pageName = window.location.href.toString().match(/\/\/[^\/]+\/([^\.]+)/)[1].replace(/\//gi, '|').replace(/--/gi, '|').replace(/#/gi, '|').replace(/-/gi, ' ').replace(/_/gi, ' ').replace(/%/gi, ' ').toLowerCase().replace(/\?.*/, '').slice(0, 100);

                if (pageName.charAt(pageName.length - 1) == '|') {
                    pageName = pageName.substr(0, pageName.length - 1);
                };

                if (pageName.indexOf("purchase") >= 0) {
                    if ($('#depModuleActive').is(":visible")) {
                        pageName = "travel|purchase|checkout|departures";
                    }
                    if ($('.chooseacabingradeActive ').is(":visible")) {
                        pageName = "travel|purchase|checkout|cabingrade";
                    }
                    if ($('.passactive').is(":visible") && $('.passactive').attr('id') == 1) {
                        pageName = "travel|purchase|passengerdetails|leadpassenger";
                    }
                    else {
                        pageName = "travel|" + pageName;
                    }
                };

                SAGA.adobe.tagging["pageName"] = pageName;

            } else {
                SAGA.adobe.tagging["pageName"] = "travel homepage";
            };

            var currentPageUrl = window.location.href.toString();

            SAGA.adobe.tagging["currentPageUrl"] = currentPageUrl;

            if (currentPageUrl.toLowerCase().indexOf("brochure-request-submitted.aspx?success=true") >= 1) {
                SAGA.adobe.tagging["formComplete"] = "true";
            }

            // need to ONLY do this when it comes from a Saga domain
            var nullReferringPage = (document.referrer.toString().match(/\/\/[^\/]+\/([^\.]+)/) == null),
                fromSagaPos = document.referrer.indexOf("saga.co.uk"),
                fromSagaTravelPos = document.referrer.indexOf("travel.saga.co.uk"),
                fromSagaDomain = fromSagaPos >= 0,
                fromSagaTravelDomain = fromSagaTravelPos >= 0;

            // if not nullReferringPage then work out what it should be and assign
            if (!nullReferringPage && fromSagaDomain) {
                var previousPageName = document.referrer.toString().match(/\/\/[^\/]+\/([^\.]+)/)[1].replace(/\//gi, '|').replace(/--/gi, '|').replace(/#/gi, '|').replace(/-/gi, ' ').replace(/_/gi, ' ').replace(/%/gi, ' ').toLowerCase().replace(/\?.*/, '').slice(0, 100);
                SAGA.adobe.tagging["previousPageName"] = previousPageName;
            } else if (fromSagaDomain) {
                //check - if it's from travel domain or the group homepage
                SAGA.adobe.tagging["previousPageName"] = fromSagaTravelDomain ? "travel homepage" : "homepage";
            } else {
                SAGA.adobe.tagging["previousPageName"] = "";
            };

            //FINALLY do this - the Sitecore values are intended to replace any defaults
            //reads in the values from the child divs of #adl_params e.g.:
            //<div id="adl_params" style="display: none;">
            //<div data-adl-key="key_name">value</div>
            //<div data-adl-key="key_2_name">value</div>
            //</div> 

            $('#adl_params>div').each(function (index) {
                var adUpKey = $(this).attr("data-adl-key"),
                    adUpValue;

                // we are persisting adl variables through BE journey..
                // clear the values if the transaction number changes
                if (adUpKey.toLowerCase() === "transactionnumber") {
                    if ($(this).text() !== localStorage.getItem("TransactionNumber")) {
                        dataLayerModule.clearCheckoutAndBookingEngineItemsFromLocalStorage($(this).text());
                    }
                }

                if (adUpKey.toLowerCase() === "pagetype") {
                    //If the current page is not a search page, booking engine page or product page then call the pageData satellite call.
                    //issues with page load data not populating, so move to direct call.
                    var urlPath = window.location.pathname.toLowerCase().replace(".aspx", "");
                    if (dataLayerModule.pageDataBlacklist.indexOf(urlPath) === -1) {
                        var pageTypeVal = $("#adl_params>div[data-adl-key='pageType']").text();
                        AdlAddUpdateItem("pageType", pageTypeVal);
                        util.satelliteTrack("pageData");
                    }
                };

                //update the global pagename if required
                if (adUpKey.toLowerCase() == "pagename") {
                    pageName = $(this).text();
                };

                // if there was a value in local storage, update it, else just call AdlAddUpdateItem
                var lsValue = localStorage.getItem(adUpKey);
                adUpValue = lsValue != null ? lsValue : $(this).text();

                //was prefixed with 'if (adUpValue != "")', but empty vars should be set too.
                AdlAddUpdateItem(adUpKey, adUpValue);
            });

            window.loadedModules('Adobe/dataLayer');
        }
    }
});
